import { render, staticRenderFns } from "./Realtime.vue?vue&type=template&id=82ba2ab2&scoped=true&"
import script from "./Realtime.vue?vue&type=script&lang=js&"
export * from "./Realtime.vue?vue&type=script&lang=js&"
import style0 from "./Realtime.vue?vue&type=style&index=0&id=82ba2ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ba2ab2",
  null
  
)

export default component.exports